// extracted by mini-css-extract-plugin
export default {"Message":"Message_Message__n3Iii","MessageShow":"Message_MessageShow__DGEt1","success":"Message_success__XUc6F","error":"Message_error__FWprS"};